import React, { lazy } from 'react';

// Lazy load components
const HelpCenterHomePage = lazy(() => import('../pages/info/HelpCenterHomePage'));
const HelpCenterLayout = lazy(() => import('../components/Layouts/HelpCenterLayout'));
const Article = lazy(() => import('../components/helpCenter/Article'));

export const helpRoutes = [
  {
    element: <HelpCenterLayout />,
    children: [
      { path: '/help', element: <HelpCenterHomePage /> },
      { path: '/help/article/:id', element: <Article /> },
    ],
  },
];
